import { bindable, customElement } from 'aurelia-framework';

@customElement('auto-import-status')
export class AutoImportStatus {
  @bindable
  params;

  url;

  attached() {
    if (this.params.data) {
      this.url = `/imported-prices/${this.params.data.availableInstrumentUuid ?? this.params.data.availableInstrumentUuid}`;
    }
  }
}
